import 'css-chunksrc/client/scenes/notifications/notification/replyToComment/styles.scss';export default {
  "notification": "_notification_19c7m_1",
  "header": "_header_19c7m_8",
  "date": "_date_19c7m_18",
  "main": "_main_19c7m_24",
  "author": "_author_19c7m_28",
  "avatar": "_avatar_19c7m_38",
  "authorName": "_authorName_19c7m_43",
  "text": "_text_19c7m_49",
  "content": "_content_19c7m_56",
  "seeMore": "_seeMore_19c7m_63"
};